<template>
  <div class="container mx-auto py-10 md:flex">
    <router-link
      :to="{name: 'strips'}"
      tag="div"
      class="cursor-pointer rounded-lg overflow-hidden shadow-lg z-0 hover:z-10 hover:shadow-xl mb-4 mx-10 lg:mx-0 lg:-mr-2"
      title="BD">
      <img class="hidden lg:block" src="img/BDacceuil.jpg">
      <img class="block lg:hidden w-full" src="img/BDacceuilVM.jpg">
      <h1 class="hidden">BD</h1>
    </router-link>

    <router-link
      :to="{name: 'illustrations'}"
      tag="div"
      class="cursor-pointer rounded-lg overflow-hidden shadow-lg z-0 hover:z-10 hover:shadow-xl mb-4 mx-10 lg:mx-0"
      title="Illustration jeunesse">
      <img class="hidden lg:block" src="img/Illustrationacceuil.jpg">
      <img class="block lg:hidden w-full" src="img/IllustrationacceuilVM.jpg">
      <h1 class="hidden">Illustration</h1>
    </router-link>

    <router-link
      :to="{name: 'originals'}"
      tag="div"
      class="cursor-pointer rounded-lg overflow-hidden shadow-lg z-0 hover:z-10 hover:shadow-xl mb-4 mx-10 lg:mx-0 lg:-ml-2"
      title="Oeuvres originales">
      <img class="hidden lg:block" src="img/oeuvresacceuil.jpg">
      <img class="block lg:hidden w-full" src="img/oeuvresacceuilVM.jpg">
      <h1 class="hidden">Oeuvres originales</h1>
    </router-link>
  </div>
</template>

<script>
export default {
}
</script>
